"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstIterableResult = getFirstIterableResult;
const getFirstIteratorResult_1 = require("../actions/getFirstIteratorResult");
function getFirstIterableResult(iterable) {
    return (0, getFirstIteratorResult_1.getFirstIteratorResult)(iterable?.[Symbol.iterator]());
}
//# sourceMappingURL=getFirstIterableResult.js.map